"use strict";
// useSignMessage.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSendNft = void 0;
const react_1 = require("react");
const helper_1 = require("../utils/helper");
const useSendNft = (calldata, authUrl = 'https://auth.tria.so') => {
    const [data, setData] = (0, react_1.useState)('');
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isError, setIsError] = (0, react_1.useState)(false);
    const sendNft = () => {
        setIsLoading(true);
        const iframeEncodedData = (0, helper_1.createEncodedData)(calldata);
        const signIframeUrl = `${authUrl}/sendNft/${iframeEncodedData}`;
        const iframe = (0, helper_1.createIframe)(signIframeUrl, 'sdkSendNft');
        setIsLoading(false);
        return signIframeUrl;
    };
    (0, react_1.useEffect)(() => {
        const detect = (event) => {
            var _a;
            if (event.origin !== authUrl)
                return;
            let eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (err) {
                eventData = event.data;
            }
            if ((eventData === null || eventData === void 0 ? void 0 : eventData.type) === 'closeIframe' && (eventData === null || eventData === void 0 ? void 0 : eventData.callFrom) == 'sendNft') {
                setData(eventData === null || eventData === void 0 ? void 0 : eventData.data);
                setIsLoading(false);
                (_a = document.getElementById('sdkSendNft')) === null || _a === void 0 ? void 0 : _a.remove();
            }
        };
        window.addEventListener('message', detect);
        return () => {
            window.removeEventListener('message', detect);
        };
    }, []);
    return { data, isLoading, isError, isSuccess: !!data, sendNft };
};
exports.useSendNft = useSendNft;
